// Renders a question's attachment. Pictures show everywhere; audio only plays on
// the host screen (players get a marker — the server withholds the URL).
import { useT } from '../i18n';
import type { PublicQuestion } from '../shared/protocol';

export function QuestionMedia({ q, host }: { q: Pick<PublicQuestion, 'mediaUrl' | 'mediaType'>; host: boolean }) {
  const t = useT();
  if (!q.mediaType) return null;
  if (q.mediaType === 'image') {
    return q.mediaUrl ? <img className="qmedia" src={q.mediaUrl} alt="" /> : null;
  }
  if (host && q.mediaUrl) {
    // Muted preload so the host can hit play the instant the question opens.
    return <audio className="qaudio" controls preload="auto" src={q.mediaUrl} />;
  }
  return <div className="qaudio-marker">🎵 {t('play.listenHost')}</div>;
}
